export const AUTH_SESSIONS = '/auth-sessions';
// {0} is reserved by the shared client for the device asset ID
export const AUTH_SESSION = '/auth-sessions/{1}';
